<template>
	<div class="app-page-header width-100 display-flex flex-row flex-justify-space-between">
		<div class="height-100 display-flex flex-column flex-justify-space-between">
			<slot name="left-side" />
			<slot name="tabs" />
		</div>
		<slot name="right-side" />
	</div>
</template>

<script>
export default {
	name: 'AppPageHeader',
};
</script>

<style lang="scss">
.app-page-header {
	max-height: 110px;
	min-height: 110px;
	background: var(--bg-color);
	padding: 16px 50px 0px 50px;
	border-bottom: 1px solid var(--border-color);

	.page-title {
		font-size: 22px;
		font-weight: 600;
		color: var(--primary-font-color);
	}

	.page-description {
		font-size: 14px;
		color: var(--secondary-font-color);
	}
}
</style>
